export type VaultPreview = {
  id: string;
  alt: string;
  src: string;
};

export const vaultPreviews: VaultPreview[] = [
  {
    id: 'main-cover',
    alt: 'The MenoReset System — 30 Days to Hormone Harmony cover page',
    src: 'https://cdn.magicpatterns.com/uploads/my8RW9UJvaPBEm7WVv9rg7/Screenshot_20260913_131535_Drive.jpg',
  },
  {
    id: 'hormonal-truths',
    alt: 'Volume 1 — The 3 Hormonal Truth-Bombs opening page',
    src: 'https://cdn.magicpatterns.com/uploads/iZQ7JxFCmRXfUGMpB9FNLu/Screenshot_20260913_131611_Drive.jpg',
  },
  {
    id: 'hibiscus-chill',
    alt: 'The Cooling Collection — Frozen Hibiscus Chill recipe page',
    src: 'https://cdn.magicpatterns.com/uploads/wA2XNKk473JeqGBPTLodhN/Screenshot_20260913_131912_Drive.jpg',
  },
  {
    id: 'detox-day-1',
    alt: 'The 7-Day Meno-Detox — Day 1 meal plan table',
    src: 'https://cdn.magicpatterns.com/uploads/fLVG31d4pFizvVwzrE1X5c/Screenshot_20260913_132027_Drive.jpg',
  },
  {
    id: 'vital-motion',
    alt: 'Volume 5 — Vital Motion low-impact exercise page',
    src: 'https://cdn.magicpatterns.com/uploads/7PFg9MSrG36znHYFhBvoLG/Screenshot_20260913_131701_Drive.jpg',
  },
  {
    id: 'omega-3',
    alt: 'The Meno-Apothecary — Omega-3 clinical dosage page',
    src: 'https://cdn.magicpatterns.com/uploads/22ntEKJKG8v5D5DTDvgnfs/Screenshot_20260913_132233_Drive.jpg',
  },
  {
    id: 'graduation',
    alt: 'MenoReset Graduation certificate of achievement',
    src: 'https://cdn.magicpatterns.com/uploads/kfeqBfU9GWW2tVr5p7vG1i/Screenshot_20260913_132334_Drive.jpg',
  },
];
